<!--Do NOT change this file manually, it is being generated by 'fws icons' command.-->

<template>
    <component v-bind:is="component"/>
</template>

<script>
    import startcase from 'lodash.startcase';
    import ArrRight from '../../../../assets/svg/ico-arr-right.svg';
    import ArrowDown from '../../../../assets/svg/ico-arrow-down.svg';
    import ArrowLeft from '../../../../assets/svg/ico-arrow-left.svg';
    import ArrowRight from '../../../../assets/svg/ico-arrow-right.svg';
    import ArrowUp from '../../../../assets/svg/ico-arrow-up.svg';
    import Bookmark from '../../../../assets/svg/ico-bookmark.svg';
    import Check from '../../../../assets/svg/ico-check.svg';
    import ChevronDownLight from '../../../../assets/svg/ico-chevron-down-light.svg';
    import ChevronDown from '../../../../assets/svg/ico-chevron-down.svg';
    import Close from '../../../../assets/svg/ico-close.svg';
    import Dog from '../../../../assets/svg/ico-dog.svg';
    import EnvelopeFull from '../../../../assets/svg/ico-envelope-full.svg';
    import FacebookBranding from '../../../../assets/svg/ico-facebook-branding.svg';
    import Facebook from '../../../../assets/svg/ico-facebook.svg';
    import Fax from '../../../../assets/svg/ico-fax.svg';
    import GooglePlus from '../../../../assets/svg/ico-google-plus.svg';
    import Happy from '../../../../assets/svg/ico-happy.svg';
    import InstagramBrands from '../../../../assets/svg/ico-instagram-brands.svg';
    import LinkedinBrands from '../../../../assets/svg/ico-linkedin-brands.svg';
    import Lock from '../../../../assets/svg/ico-lock.svg';
    import Mail from '../../../../assets/svg/ico-mail.svg';
    import MapMarkerAlt from '../../../../assets/svg/ico-map-marker-alt.svg';
    import Paperclip from '../../../../assets/svg/ico-paperclip.svg';
    import PhoneFull from '../../../../assets/svg/ico-phone-full.svg';
    import Phone from '../../../../assets/svg/ico-phone.svg';
    import Pin from '../../../../assets/svg/ico-pin.svg';
    import Play from '../../../../assets/svg/ico-play.svg';
    import PlusCircle from '../../../../assets/svg/ico-plus-circle.svg';
    import Plus from '../../../../assets/svg/ico-plus.svg';
    import Poly from '../../../../assets/svg/ico-poly.svg';
    import Polygon from '../../../../assets/svg/ico-polygon.svg';
    import Search from '../../../../assets/svg/ico-search.svg';
    import TwitterSquareBrands from '../../../../assets/svg/ico-twitter-square-brands.svg';
    import Twitter from '../../../../assets/svg/ico-twitter.svg';
    import User from '../../../../assets/svg/ico-user.svg';

    export default {
        props: {
            iconName: {
                type: String,
                required: true
            }
        },
        components: {
            ArrRight,
            ArrowDown,
            ArrowLeft,
            ArrowRight,
            ArrowUp,
            Bookmark,
            Check,
            ChevronDownLight,
            ChevronDown,
            Close,
            Dog,
            EnvelopeFull,
            FacebookBranding,
            Facebook,
            Fax,
            GooglePlus,
            Happy,
            InstagramBrands,
            LinkedinBrands,
            Lock,
            Mail,
            MapMarkerAlt,
            Paperclip,
            PhoneFull,
            Phone,
            Pin,
            Play,
            PlusCircle,
            Plus,
            Poly,
            Polygon,
            Search,
            TwitterSquareBrands,
            Twitter,
            User,

        },
        computed: {
            component() {
                return startcase(this.iconName.replace('ico-', '')).replace(' ', '');
            }
        }
    };
</script>
